import { render, staticRenderFns } from "./GameMobile.vue?vue&type=template&id=b728d50e&scoped=true&"
import script from "./GameMobile.vue?vue&type=script&lang=js&"
export * from "./GameMobile.vue?vue&type=script&lang=js&"
import style0 from "./GameMobile.vue?vue&type=style&index=0&id=b728d50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b728d50e",
  null
  
)

export default component.exports